import Prism from "prismjs";
import "prismjs/plugins/autoloader/prism-autoloader";
import "prismjs/plugins/keep-markup/prism-keep-markup";

Prism.plugins.autoloader.languages_path = "/static/js/dist/prism-components/";

export default Prism;
